import service from '../request/index'

// 轮播图列表
export function getBannerList(data) {
  return service({
    url: '/banner/index',
    method: "post",
    data
  })
}
// 栏目图设置
export function getColumnImages(data) {
  return service({
    url: '/column_image/index',
    method: "post",
    data
  })
}
// 关于我们
export function getAboutUst(data) {
  return service({
    url: '/about_us/index',
    method: "post",
    data
  })
}
// 工程业绩管理列表
export function getAchievements(data) {
  return service({
    url: '/engineering_achievements/index',
    method: "post",
    data
  })
}
// 企业资质管理列表
export function getBusiness(data) {
  return service({
    url: '/business_qualification/index',
    method: "post",
    data
  })
}
// 联系我们
export function getContactInfo(data) {
  return service({
    url: '/contact_us/info',
    method: "post",
    data
  })
}
// 公司简介管理列表
export function getCompanyProfile(data) {
  return service({
    url: '/company_profile/index',
    method: "post",
    data
  })
}
// 人才战略管理列表
export function getTalentStrategy(data) {
  return service({
    url: '/talent_strategy/index',
    method: "post",
    data
  })
}
// 动态信息管理列表
export function getDynamic(data) {
  return service({
    url: '/dynamic_information/index',
    method: "post",
    data
  })
}
// 动态信息管理详情
export function getDynamicInfo(data) {
  return service({
    url: '/dynamic_information/info',
    method: "post",
    data
  })
}
// 新闻中心管理列表
export function getNews(data) {
  return service({
    url: '/news/index',
    method: "post",
    data
  })
}
// 新闻中心管理列表
export function getNewsInfo(data) {
  return service({
    url: '/news/info',
    method: "post",
    data
  })
}
// 发展历程管理列表
export function getDevelopmentHistory(data) {
  return service({
    url: '/development_history/index',
    method: "post",
    data
  })
}
